import { ODataSelect } from "../../../../../Providers.Api/ODataQuery";

export class Equipment extends ODataSelect
{
    
    Node_Id = 0;
    Equip_Id = "";
    Equip_Name = "";
    Equip_Class = "";
    Equip_Type = "";
    Equip_IsEnabled = 0;
    Equip_Tag_No = "";
    Equip_Serial_No = "";
    Store_Space_Id = "";
    Equip_Status = "";
    ImageURI = "";
    Equip_Category = "";
}

export class storeDetails extends ODataSelect
{
    Node_Id = 0;
    Space_Id = "";
    Space_Name = "";
    Space_Type =  "";
}